import { get } from "./index"
 
 export const getAll = () => {
    return new Promise((resolve, rej) => {
        get('api/subscription/list')
        .then(res => resolve(res.data))
        .catch(e => {rej(e.response.data.message)}) 
    }) 
  }